import { createSlice } from "@reduxjs/toolkit";
import { initialState } from "./initial-state";
import { confirmDelivery } from "./thunks/confirm-delivery";

export const slice = createSlice({
  name: "confirm",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(confirmDelivery.pending, (state) => {
        state.isConfirming = true;
        state.errorMessage = "";
      })
      .addCase(confirmDelivery.fulfilled, (state) => {
        state.isConfirming = false;
        state.isConfirmed = true;
      })
      .addCase(confirmDelivery.rejected, (state, action) => {
        state.isConfirming = false;
        state.errorMessage = action.error.message ?? "";
      });
  },
});

export const reducer = slice.reducer;
